import React, { useState, useEffect } from "react";
import { LANDING } from "@/constants/testIds";

export default function Nav({ onJoin }) {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <nav
      data-testid={LANDING.nav}
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[hsl(var(--scrm-bg))]/85 backdrop-blur-md border-b hairline"
          : "bg-transparent"
      }`}
    >
      <div className="flex items-center justify-between px-6 md:px-10 h-14 md:h-16">
        <a
          href="#top"
          data-testid={LANDING.navLogo}
          className="font-display uppercase tracking-[0.04em] text-[hsl(var(--scrm-cream))] text-sm md:text-base"
        >
          SCRM CLUB
        </a>

        <div className="hidden md:flex items-center gap-8">
          <a
            href="#drop"
            className="font-body text-xs uppercase tracking-[0.22em] text-[hsl(var(--scrm-cream))]/75 hover:text-[hsl(var(--scrm-cream))] transition-colors"
          >
            Drop 001
          </a>
          <a
            href="#how"
            className="font-body text-xs uppercase tracking-[0.22em] text-[hsl(var(--scrm-cream))]/75 hover:text-[hsl(var(--scrm-cream))] transition-colors"
          >
            How It Works
          </a>
          <a
            href="#archive"
            className="font-body text-xs uppercase tracking-[0.22em] text-[hsl(var(--scrm-cream))]/75 hover:text-[hsl(var(--scrm-cream))] transition-colors"
          >
            The Universe
          </a>
        </div>

        <button
          data-testid={LANDING.navJoinBtn}
          onClick={onJoin}
          className="btn-cream font-body uppercase tracking-[0.22em] text-[10px] md:text-[11px] px-4 md:px-6 py-2.5 md:py-3"
        >
          Join Waitlist
        </button>
      </div>
    </nav>
  );
}
